import * as React from "react"

const DrinkSakeItem = ({ item }) => {
  return (
    <div className={`detailItem ${item.vertical ? 'detailItem-vertical': ''}`}>
      <div className="w100">
        <h3>{item.name}</h3>
        {item.description && (
          <p className="detailItem-description">{item.description}</p>
        )}
      </div>
      {item.price && (
        <div className="detailItem-price--wrap">
            <p className="detailItem-price">${item.price}</p>
        </div>
      )}
      {item.price1 && (
        <div className="detailItem-price--wrap w40">
            <p className="detailItem-price detailItem-price--right">{item.price1Text} <span className="detailItem-price">${item.price1}</span></p>
            <p className="detailItem-price detailItem-price--right">{item.price2Text} <span className="detailItem-price">${item.price2}</span></p>
            <p className="detailItem-price detailItem-price--right">{item.price3Text} <span className="detailItem-price">${item.price3}</span></p>
        </div>
      )}
    </div>
  )
}

export default DrinkSakeItem
